import React, { useState, useMemo } from 'react';
import PlusButton from '../../_common/elements/PlusButton';
import { Link, useNavigate } from 'react-router-dom';

import componentFunctions from '../../../../services/tools/componentFunctions';

import css from './ContractsTable.module.css';

// import {varStyles} from './CDGeneral.js';

const varStyles = {
    contractStatus: {
        Negotiations: css.gray,
        'Raise requests': css.red,
        'All requests raised': css.orange,
        Completed: css.green,
    },
    documentStatus: {
        New: css.gray,
        Signed: css.green,
        'No contract': css.orange,
        Internal: css.blue,
        Cancelled: css.black,
    },
    paymentStatus: {
        'No payment': css.red,
        'Invoices send': css.orange,
        Alternative: css.blue,
        'Payed partially': css.yellow,
        'Payed in full': css.green,
    },
};

function ContractsTable({ data, showModal }) {
    const [filter, setFilter] = useState('');
    const [showCompleted, setShowCompleted] = useState(true);
    const [sortConfig, setSortConfig] = useState(componentFunctions.sortConfig);
    const requestSort = (key) => componentFunctions.requestSort(key, sortConfig, setSortConfig);
    const navigate = useNavigate();

    const sortedAndFilteredData = useMemo(() => {
        return componentFunctions.sortedAndFilteredData(data, sortConfig, filter)
        .filter((x) => (showCompleted ? x.contractStatusTitle !== 'Completed' : true));
    }, [data, sortConfig, filter, showCompleted]);

    if (!data || !data.length) {
        return <p>No data available.</p>;
    }

    const headers = Object.keys(data[0]);

    const handleShowCompletedFilter = () => {
        setShowCompleted((state) => !state);
    };

    // console.log(data);

    return (
        <>
            <div className={css.control}>
                <input
                    type="text"
                    placeholder="Filter results..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className={css.filterInput}
                />
                <div className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}>
                    {' '}
                    {sortedAndFilteredData.length}{' '}
                </div>
                <PlusButton onClick={showModal} />
            </div>
            <div style={{ textAlign: 'right', marginTop: '5px', color: 'red', fontSize: '1.2rem' }}>
                <label>
                    Show Completed?
                    <input type="checkbox" onChange={handleShowCompletedFilter} checked={!showCompleted} value={showCompleted} />
                </label>
            </div>

            <table className={css.table}>
                <thead className={css.thead}>
                    <tr>
                        <th onClick={() => requestSort('contractTitle')} className={css.th}>
                            Title
                            {sortConfig.key === 'contractTitle' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort('customerName')} className={css.th}>
                            Customer
                            {sortConfig.key === 'customerName' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        {/* <th className={css.th}>Amount</th> */}
                        <th onClick={() => requestSort('contractDocumentStatusTitle')} className={`${css.th} ${css.center}`}>
                            Document
                            {sortConfig.key === 'contractDocumentStatusTitle' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort('contractPaymentStatusTitle')} className={`${css.th} ${css.center}`}>
                            Payment
                            {sortConfig.key === 'contractPaymentStatusTitle' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th onClick={() => requestSort('contractStatusTitle')} className={`${css.th} ${css.center}`}>
                            Status
                            {sortConfig.key === 'contractStatusTitle' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th className={`${css.th} ${css.center}`}>Requests</th>
                        <th onClick={() => requestSort('createdRequests')} className={css.th}>
                            Created
                            {sortConfig.key === 'createdRequests' ? (sortConfig.direction === 'ascending' ? ' 🔼' : ' 🔽') : ''}
                        </th>
                        <th className={css.th}>
                            <i class="fa-solid fa-paperclip"></i>
                        </th>
                        <th className={css.th}>Notes</th>
                    </tr>
                </thead>
                <tbody className={css.tbody}>
                    {sortedAndFilteredData.length > 0 ? (
                        sortedAndFilteredData.map((item, index) => (
                            <tr
                                key={item.contractId}
                                id={item.contractId}
                                onClick={() => navigate(`/contract/details/${item.contractId}`)}
                                className={css.row}
                            >
                                <td>{item.contractTitle}</td>
                                <td>{item.customerName}</td>
                                {/* <td className={css.right}>{item.contractTotalAmount}</td> */}
                                <td className={varStyles.documentStatus[item.contractDocumentStatusTitle]}><span>{item.contractDocumentStatusTitle}</span></td>
                                <td className={varStyles.paymentStatus[item.contractPaymentStatusTitle]}><span>{item.contractPaymentStatusTitle}</span></td>
                                <td className={varStyles.contractStatus[item.contractStatusTitle]}><span>{item.contractStatusTitle}</span></td>
                                <td className={css.center}>{item.contractRequests}</td>
                                <td className={css.center}>{item.createdRequests}</td>
                                <td className={`${css.center} ${css.certificates}`}>
                                    {item.contractLink && (
                                        <Link to={item.contractLink} target="_blank" rel="noopener noreferrer">
                                            <i className="fa-regular fa-file-lines"></i>{' '}
                                        </Link>
                                    )}
                                </td>
                                <td>{item.contractNotes}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                                No matching records found. Please adjust your filter.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </>
    );
}

export default ContractsTable;
